import { render, staticRenderFns } from "./AppEditProject.vue?vue&type=template&id=7ab5d8b0&"
import script from "./AppEditProject.vue?vue&type=script&lang=js&"
export * from "./AppEditProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports